import React from "react";
import { pdf } from "@react-pdf/renderer";
import DischargeSurveyCommentsPdfDoc from "../components/ReportPdf/DischargeSurveyCommentsPdfDoc";
import { REPORT_EMPTY_DISPLAY } from "./ReportDashboard";

export const DISCHARGE_FEEDBACK_COMMENTS_PAGE_SIZE = 20;
export const DISCHARGE_SURVEY_COMMENTS_EXPORT_FILE_NAME = "Discharge_Survey_Comments";

export const DISCHARGE_FEEDBACK_COMMENTS_DEFAULT_SORT_BY = "patient";
export const DISCHARGE_FEEDBACK_COMMENTS_DEFAULT_SORT_DIRECTION = "ASC";

export const DISCHARGE_FEEDBACK_COMMENT_COLUMNS = [
  { key: "patient", header: "Patient", sortable: true },
  { key: "recoveryAnswer", header: "Yes / No", sortable: true },
  { key: "npsRating", header: "NPS Rating", sortable: true },
  { key: "program", header: "Program", sortable: true },
  { key: "prompt", header: "Prompt", sortable: true },
  { key: "comment", header: "Comment", sortable: true },
];

const escapeCsvCell = (value) => {
  if (value == null || value === "") return "";
  const str = String(value);
  if (str.includes(",") || str.includes('"') || str.includes("\n")) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

export const parseDischargeFeedbackCommentsPage = (response) => {
  const data = response?.data?.data ?? response?.data ?? {};
  const comments = data.comments ?? {};
  const list = Array.isArray(comments.pageContent) ? comments.pageContent : [];
  const pageNo = comments.pageNo ?? 0;
  const totalPage = comments.totalPage ?? 1;

  return {
    list,
    pageNo,
    pageSize: comments.pageSize ?? DISCHARGE_FEEDBACK_COMMENTS_PAGE_SIZE,
    totalPage,
    totalRecords: comments.totalRecords ?? list.length,
    appliedFilters: data.appliedFilters ?? null,
  };
};

export const convertDischargeFeedbackCommentsToCsv = (rows) => {
  const safeRows = mapDischargeFeedbackCommentsForExport(rows);

  return [
    DISCHARGE_FEEDBACK_COMMENT_COLUMNS.map((col) => col.header).join(","),
    ...safeRows.map((row) => DISCHARGE_FEEDBACK_COMMENT_COLUMNS
      .map((col) => escapeCsvCell(row[col.key]))
      .join(",")),
  ].join("\n");
};

const triggerFileDownload = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const mapDischargeFeedbackCommentsForExport = (rows) => (
  Array.isArray(rows) ? rows : []
).map((row) => DISCHARGE_FEEDBACK_COMMENT_COLUMNS.reduce((acc, col) => {
  const value = row[col.key];
  acc[col.key] = value != null && value !== "" ? String(value) : REPORT_EMPTY_DISPLAY;
  return acc;
}, {}));

export const downloadDischargeFeedbackCommentsCsv = (rows) => {
  const csvData = convertDischargeFeedbackCommentsToCsv(rows);
  const blob = new Blob([csvData], { type: "text/csv" });
  triggerFileDownload(blob, `${DISCHARGE_SURVEY_COMMENTS_EXPORT_FILE_NAME}.csv`);
};

export const downloadDischargeFeedbackCommentsPdf = async (rows) => {
  const exportRows = mapDischargeFeedbackCommentsForExport(rows);
  const pdfBlob = await pdf(
    <DischargeSurveyCommentsPdfDoc
      data={exportRows}
      columns={DISCHARGE_FEEDBACK_COMMENT_COLUMNS}
    />
  ).toBlob();
  triggerFileDownload(pdfBlob, `${DISCHARGE_SURVEY_COMMENTS_EXPORT_FILE_NAME}.pdf`);
};
